
export const FUEL_ROUTES = [
  {
    path: "fuelDetailsForm",
    name: "fuelDetailsForm",
    component: () =>
        import(/* webpackChunkName: "fuel" */ "@/modules/fuel/components/forms/FuelDetailsForm")
  },
  {
    path: "fuelCardForm",
    name: "fuelCardForm",
    component: () =>
        import(/* webpackChunkName: "fuel" */ "@/modules/fuel/components/forms/FuelCardForm.vue")
  },
  {
    path: "fuelOverview",
    name: "fuelOverview",
    component: () =>
        import(/* webpackChunkName: "fuel" */ "@/modules/fuel/layouts/FuelOverview")
  },
  {
    path: "fuelRequisitionForm",
    name: "fuelRequisitionForm",
    component: () =>
        import(/* webpackChunkName: "fuel" */ "@/modules/fuel/components/forms/FuelRequisitionForm")
  },
  {
    path: "fuelRequisitionOverview",
    name: "fuelRequisitionOverview",
    component: () =>
        import(/* webpackChunkName: "fuel" */ "@/modules/fuel/layouts/FuelRequisitionOverview")
  }
];
